var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95559 13.3315L13.4398 2.80005L19.924 13.3315H6.95559ZM20.0714 26.6C18.6173 26.6 17.3991 26.1042 16.4166 25.1125C15.4342 24.1209 14.943 22.8912 14.943 21.4235C14.943 19.9559 15.4342 18.7262 16.4166 17.7345C17.3991 16.7429 18.6173 16.247 20.0714 16.247C21.5254 16.247 22.7437 16.7429 23.7261 17.7345C24.7086 18.7262 25.1998 19.9559 25.1998 21.4235C25.1998 22.8912 24.7086 24.1209 23.7261 25.1125C22.7437 26.1042 21.5254 26.6 20.0714 26.6ZM2.7998 25.8563V16.8123H11.7598V25.8563H2.7998ZM20.0739 24.815C21.0154 24.815 21.8103 24.487 22.4588 23.8308C23.1072 23.1746 23.4314 22.3714 23.4314 21.421C23.4314 20.4707 23.1063 19.6683 22.4563 19.0138C21.8062 18.3593 21.0104 18.032 20.0689 18.032C19.1274 18.032 18.3324 18.3601 17.684 19.0163C17.0356 19.6725 16.7114 20.4757 16.7114 21.4261C16.7114 22.3764 17.0364 23.1788 17.6865 23.8333C18.3366 24.4878 19.1324 24.815 20.0739 24.815ZM4.56823 24.0713H9.99138V18.5973H4.56823V24.0713ZM10.1388 11.5465H16.7409L13.4398 6.1618L10.1388 11.5465Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.882e6efe82d27a163e20ab553bd0f51d.svg";
export { ForwardRef as ReactComponent };